import React, { useState } from "react";
import { CircularProgress } from "@material-ui/core";
import FormDialog from "components/FormDialog";
import { useDispatch, useSelector } from "react-redux";
import AddTags from "./AddTags";
import {
  customerCheck,
  selectBombotTags,
  selectFanpageSelected,
  selectFilterCus,
  selectIsShowModal
} from "views/Customer/CustomerSelectors";
import customerApi from "api/customerApi";
import { toggleModalAdd } from "views/Customer/CustomerReducer";
import { useTranslation } from "react-i18next";
import { openToast } from "stores/toast/slice.toast";
import listStyles from "../ListCustomer.module.scss";

const ModalTagsBombot = ({
  handleClose,
  open = true,
  isRemove,
  setMessageType,
  customerAfterFilter = [],
  selectAllPages = false,
  activeSearch = "",
  selectedCount = 0,
}) => {
  const fanpage_selected = useSelector(selectFanpageSelected);
  const bombotTags = useSelector(selectBombotTags);
  const dispatch = useDispatch();
  const [tagSelected, setTagSelected] = useState([]);
  const showModalCreate = useSelector(selectIsShowModal);
  const customerExclude = useSelector(customerCheck);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  const filterCus = useSelector(selectFilterCus);

  const onSave = async () => {
    setIsLoading(true);
    setMessageType && setMessageType(null);
    // Search phải phản ánh đúng filter/search hiện tại của danh sách khách hàng.
    // activeSearch được build từ pageId + search + các điều kiện filter đang áp dụng.
    const baseSearch =
      activeSearch ||
      filterCus?.search_string ||
      (fanpage_selected?.id ? `pageId==${fanpage_selected.id}` : "");

    // Chọn lẻ: giới hạn đúng các khách hàng đã check bằng uid=in thay vì dựa vào
    // exclude (customerAll không chứa đủ danh sách khách của page).
    const selectedUids = [
      ...new Set(customerAfterFilter.map((cus) => cus.uid).filter(Boolean))
    ];

    let searchQuery = baseSearch;
    if (!selectAllPages && selectedUids.length) {
      const uidQuery = `uid=in=${selectedUids.join(",")}`;
      searchQuery = baseSearch ? `${baseSearch};${uidQuery}` : uidQuery;
    }

    const payload = {
      search: searchQuery,
      exclude: selectAllPages
        ? customerExclude.map((cus) => cus.uid).filter(Boolean)
        : [],
      bombotTags: tagSelected.map((t) => t.id)
    };

    try {
      let res;
      if (isRemove) {
        res = await customerApi.removeMultiCustomersBombotTags(payload);
      } else {
        res = await customerApi.addMultiCustomersBombotTags(payload);
      }
      if (res === true) {
        dispatch(
          openToast({
            type: "success",
            message: t("customer_management.toast.success")
          })
        );
        handleClose();
      } else {
        setMessageType && setMessageType("error");
      }
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: t("customer_management.toast.error")
        })
      );
      setMessageType && setMessageType("error");
    } finally {
      setIsLoading(false);
      window.location.reload();
    }
  };

  const toggleModalCreate = () => {
    dispatch(toggleModalAdd());
  };

  const countCustomer = selectAllPages
    ? selectedCount
    : (customerAfterFilter.length ? customerAfterFilter.length : customerExclude.length);

  const filteredBombotTags = React.useMemo(() => {
    if (customerAfterFilter.length > 0) {
      const tagSet = new Set();
      customerAfterFilter.forEach(c => {
        if (c.bombotTags) {
          c.bombotTags.forEach(t => tagSet.add(String(typeof t === 'object' ? t.id : t)));
        }
      });
      
      if (isRemove) {
        // Gỡ tag: hiển thị các tag mà các khách hàng ĐANG CÓ (union)
        return bombotTags.filter(tag => tagSet.has(String(tag.id)));
      } else {
        // Thêm tag: trừ đi các tag khách hàng ĐÃ CÓ
        return bombotTags.filter(tag => !tagSet.has(String(tag.id)));
      }
    }
    return bombotTags;
  }, [bombotTags, customerAfterFilter, isRemove]);

  return (
    <>
      <FormDialog isOpen={open} handleClose={handleClose} withoutHeader width="440px">
        <div className={listStyles.modalHd}>
          <div className={listStyles.modalTitle}>
            {isRemove
              ? t("customer_management.remove_bombot_tag.title")
              : t("customer_management.add_bombot_tag.title")}
          </div>
          <button className={listStyles.modalClose} onClick={handleClose}>
            <svg viewBox="0 0 14 14"><path d="M3 3l8 8M11 3l-8 8"/></svg>
          </button>
        </div>

        <div className={listStyles.modalBd}>
          <div className={listStyles.formLbl} style={{marginBottom: 8}}>
            {isRemove ? 'Gỡ tag khỏi ' : 'Gắn tag cho '} 
            {countCustomer} khách hàng
          </div>

          <div className={listStyles.tagPool} style={{maxHeight: 180}}>
            {filteredBombotTags.length === 0 && (
              <div style={{fontSize: 12.5, color: 'var(--text-tertiary)', padding: '10px 0'}}>
                Không có tag nào khả dụng.
              </div>
            )}
            {filteredBombotTags.map(tag => {
              const isSelected = tagSelected.some(t => t.id === tag.id);
              return (
                <span 
                  key={tag.id}
                  className={`${listStyles.tagPick} ${isSelected ? listStyles.tagPickOn : ''}`}
                  onClick={() => {
                    if (isSelected) setTagSelected(prev => prev.filter(t => t.id !== tag.id));
                    else setTagSelected(prev => [...prev, tag]);
                  }}
                >
                  {tag.name}
                </span>
              );
            })}
          </div>
        </div>

        <div className={listStyles.modalFt}>
  
          <button className={`${listStyles.btn} ${listStyles.btnGhost}`} onClick={handleClose} disabled={isLoading}>
            {t("common.btn.cancel")}
          </button>
          <button 
            className={`${listStyles.btn} ${listStyles.btnPrimary}`} 
            onClick={onSave} 
            disabled={isLoading || tagSelected.length === 0}
          >
            {isLoading ? <CircularProgress size={12} color="inherit" style={{marginRight: 6}} /> : null}
            {t("common.btn.apply") || "Áp dụng"}
          </button>
        </div>
      </FormDialog>

      <AddTags
        open={showModalCreate}
        handleClose={toggleModalCreate}
        fanpage_selected={fanpage_selected}
      />
    </>
  );
};

export default ModalTagsBombot;
